/**
 * Lalay activity feed — wraps /wp-json/lalay/v1/activity.
 */

import { getToken } from './auth';

const BASE = '/wp-json/lalay/v1';

function timeAgo(iso) {
  if (!iso) return '';
  const date = new Date(iso.replace(' ', 'T') + 'Z');
  const sec = Math.max(1, Math.floor((Date.now() - date.getTime()) / 1000));
  if (sec < 60) return `${sec}s ago`;
  if (sec < 3600) return `${Math.floor(sec / 60)}m ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)}h ago`;
  if (sec < 7 * 86400) return `${Math.floor(sec / 86400)}d ago`;
  return date.toLocaleDateString();
}

export async function fetchActivity() {
  const tok = getToken();
  if (!tok) return [];
  try {
    const res = await fetch(`${BASE}/activity`, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    const body = await res.json().catch(() => null);
    if (res.ok && body?.success) {
      return (body.activity || []).map((a) => ({
        ...a,
        time: timeAgo(a.createdAt),
      }));
    }
  } catch {}
  return [];
}
